<footer class="footer_wrap">
  <div class="container">
    <ul class="f_link">
      <li><a href="javascript:void(0)">Privacy Policy</a></li>
      <li><a href="javascript:void(0)">Terms & Condition</a></li>
      <li><a href="javascript:void(0)">ARK Tech Team</a></li>
    </ul>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12">
        <p class="info_text">{{copyrightText}}</p>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12">
        <ul class="f_mail">
          <li>
            <i class="ri-phone-fill"></i>
            <a href="tel:{{footerPhone}}" target="_blank">{{footerPhone}}</a>
          </li>
          <li>
            <i class="ri-mail-fill"></i>
            <a href="mailto:{{footerEmail}}" target="_blank">{{footerEmail}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>